module.exports = __webpack_public_path__ + "img/jia.19d53247.svg";